import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const EmailField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  return (
    <Form.Field name="email" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">이메일 주소</Form.Label>
      <Form.TextField
        type="email"
        placeholder={placeholder || '이메일 주소를 입력해 주세요'}
        fullWidth
        readOnly={readOnly}
        disabled={disabled}
      />
      <Form.Message />
    </Form.Field>
  )
}
